export class AppService {
  constructor({ http, auth, store }) {
    this.http = http;
    this.auth = auth;
    this.store = store;
  }
}
